import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const TinyUrlTable = ({
    tinyUrls,
    setSelectedTinyUrl,
    loading,
    editOnClick,
    createOnClick,
    previewOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} previewOnClick={previewOnClick} id={item.tinyUrlId} item={item} deleteOnClick={deleteOnClick} />
            ),
        },
        {
            name: 'TinyUrlId',
            fieldName: 'tinyUrlId',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Tiny Url',
            fieldName: 'tinyUrl',
            minWidth: 150,
            maxWidth: 150,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
            onRender: (item) =>
                item.platformDomainMask && item.redirectUrl.startsWith('/') ? ( 
                    <a href={`http://${item.platformDomainMask}/t/${item.tinyUrl}`} target="_blank" rel="noopener noreferrer">
                        {item.tinyUrl}
                    </a>
                    
                ) : (
                    <a href={item.redirectUrl} target="_blank" rel="noopener noreferrer">
                        {item.tinyUrl}
                    </a>
                ),
        },
        {
            name: 'Redirect Url',
            fieldName: 'redirectUrl',
            minWidth: 400,
            maxWidth: 450,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
            onRender: (item) =>
                item.platformDomainMask && item.redirectUrl.startsWith('/') ? (
                    <a href={`http://${item.platformDomainMask}${item.redirectUrl}`} target="_blank" rel="noopener noreferrer">
                        {item.redirectUrl}
                    </a>
                ) : (
                    <a href={item.redirectUrl} target="_blank" rel="noopener noreferrer">
                        {item.redirectUrl}
                    </a>
                ),
        },
        {
            name: 'Created On',
            fieldName: 'createdOn',
            minWidth: 200,
            maxWidth: 250,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Brand',
            fieldName: 'platformId',
            minWidth: 300,
            maxWidth: 350,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
            onRender: (item) =>
                item.platformId ? (item.platformId === 1 ? 'iGrad' : 'Enrich') : null,
        },
    ];

    const items = tinyUrls ?? [];

    const selectionHook = (items) => {
        setSelectedTinyUrl(items && items[0] && items[0].tinyUrlId);
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={'name'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Tiny Url"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Tiny Urls"
                summary="This table displays all tiny URLs, including the short URL, redirect URL, creation date, and brand. You can add, edit, or delete tiny URLs. The Tiny URL feature allows admins to create and manage short links for easier sharing and tracking across the platform."
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, item?.tinyUrl || item?.name || item?.slug || ""),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default TinyUrlTable;
